import React from 'react';
import { isMobile } from 'react-device-detect';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { connect } from 'react-redux';
import './Rewards.scss';
const rewardYellow = '/img/home/completo.svg';
const rewardGray = '/img/home/desabilitado.svg';
const rewardMint = '/img/home/completo-adicional.svg';

const Rewards = (props) => {

  const { 
    authClient: { 
      awardPerfil: {
        look,
        about,
        holder,
        collaborators,
        experience,
        contact,
        site,
      },
      awardAditional: {
        cost,
        pictures,
        videos,
        shareProfile,
        highQualification,
      },
      role,
    }
  } = props;

  const small = useMediaQuery('(max-width:425px)');

  const lawyerAwardsArray = [look, about, experience, contact, site];
  const lawfirmAwardsArray = [look, about, holder, collaborators, experience, contact, site];
  const aditionalArray = [cost, pictures, videos, shareProfile, highQualification];

  const calculateProfileAchievements = () => {
    let quantity
    if (role === 'lawyer') {
      quantity = lawyerAwardsArray.filter(element => element)
    } else {
      quantity = lawfirmAwardsArray.filter(element => element)
    }
    return quantity.length
  }

  const calculateAditionalAchievements = () => {
    const quantity = aditionalArray.filter(element => element)
    return quantity.length
  }

  let PROFILE_LIMIT
  if (role === 'lawyer') {
    PROFILE_LIMIT = 5
  } else {
    PROFILE_LIMIT = 7
  }
  const ACHIEVEMENTS_LIMIT = 5

  return (
    <div className="card-rewards-content">
      <div className={`reward-list${isMobile && small? '-mobile':''}`}>
        <div>
          <p className="title title-14">Recompensas del perfil</p>
          <div className="reward-icons">
            <span className="title-28">{calculateProfileAchievements()}/{PROFILE_LIMIT}</span>
            <div style={{display: 'block', flexShrink: 1, width: '65%'}}>
              {role === 'lawyer' ? lawyerAwardsArray &&
              lawyerAwardsArray.sort().reverse()
                .map((element) => {
                  if (element) {
                    return (
                      <img
                        className="reward"
                        src={rewardYellow}
                        alt="logro obtenido"
                      />
                    )
                  } else {
                    return (
                      <img
                        className="reward"
                        src={rewardGray}
                        alt="logro no obtenido"
                      />
                    )
                  }
                }) : lawfirmAwardsArray &&
                lawfirmAwardsArray.sort().reverse()
                .map((element) => {
                  if (element) {
                    return (
                      <img
                        className="reward"
                        src={rewardYellow}
                        alt="logro obtenido"
                      />
                    )
                  } else {
                    return (
                      <img
                        className="reward"
                        src={rewardGray}
                        alt="logro no obtenido"
                      />
                    )
                  }
                })
              }
            </div>
          </div>
        </div>
        <div>
          <p className="title title-14">Recompensas adicionales</p>
          <div className="reward-icons" style={{ marginBottom: 0 }}>
            <span className="title-28">{calculateAditionalAchievements()}/{ACHIEVEMENTS_LIMIT}</span>
            {lawfirmAwardsArray && aditionalArray.sort().reverse()
                .map((element) => {
                  if (element) {
                    return (
                      <img
                        className="reward"
                        src={rewardMint}
                        alt="logro obtenido"
                      />
                    )
                  } else {
                    return (
                      <img
                        className="reward"
                        src={rewardGray}
                        alt="logro no obtenido"
                      />
                    )
                  }
                })
              }
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  authClient: state.authClient,
})

export default connect(mapStateToProps, null)(Rewards);
